import React, { useState, useEffect } from "react";
import _ from "lodash";

// ---- import components ---- //
import FileNameInput from "./inputs/fileNameInput";
import ButtonUpload from "./buttons/ButtonUpload";
import ButtonExport from "./buttons/ButtonExport";
import Inputs from "./inputs/inputs";
import ButtonSave from "./buttons/ButtonSave";

// ---- material-UI ==== //
import { FormControl, Select, MenuItem } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

// ---- firebase ---- //
import firebase from "./firebase";

function Mains() {
  // ---- FileNameInput ---- //
  const [changeNameFile, setChangeFileName] = useState("filename");
  // ---- Data from JSON ---- //
  const [Data, setData] = useState(null);
  // ---- Data filtered to default Data ---- //
  const [defaultData, setDefaultData] = useState([]);
  // ---- Change default Data
  const [changeDefaultData, setChangeDefaultData] = useState([]);
  // ---- Open select language ---- //
  const [openSelect, setOpenSelect] = useState(false);
  // ---- Language ---- //
  // eslint-disable-next-line no-unused-vars
  const [lang, setLang] = useState([]);

  // ======================================================= //

  useEffect(() => {
    if (!Data) return;
    let filtered = [];
    const filterData = (fill, path = "") => {
      const entries = Object.entries(fill);
      entries.forEach((val) => {
        if (typeof val[1] === "object") {
          filterData(val[1], path + "." + val[0]);
        } else {
          filtered.push({
            key: path + "." + val[0],
            value: val[1],
          });
        }
      });
    };
    // zde se vezme první objekt bez EN, který se bude setovat do inputu
    filterData(Data);
    // set filtered to defaultData
    setDefaultData(filtered);
    // clone default data
    const cloneData = clone(filtered);

    console.log(Data.en);

    //

    // set change default data
    setChangeDefaultData(cloneData);

    // console logs //
    console.log(Data, "Data při importu --> celý JSON");
    console.log(filtered, "vyfiltrované Data");

    const langData = firebase.database().ref("language");
    // eslint-disable-next-line no-unused-vars
    const databaseLang = langData.on("value", (snap, lang = []) => {
      setLang(snap.val());
    });
  }, [Data]);

  // clone Data of filtered

  const clone = (filtered = []) => {
    console.log(filtered, "clone-param");
    let deep = _.cloneDeep(filtered);
    deep = deep.map((val) => ({
      key: val.key,
      value: "",
    }));
    return deep;
  };

  // get Data JSON to importFile
  const JSOnDataReader = (event) => {
    setData(event);
  };

  // import file
  const importFile = (event) => {
    const input = event.target;
    if (input.files.length) {
      let reader = new FileReader();
      reader.onload = () => {
        const JSONReader = JSON.parse(reader.result);
        JSOnDataReader(JSONReader);
      };
      reader.readAsText(input.files[0]);
      const FileNameInput = input.files[0].name.substring(
        0,
        input.files[0].name.length - 5
      );
      setChangeFileName(FileNameInput);
    }
  };

  return (
    <div className="mainSize">
      <div className="buttons">
        <ButtonUpload openFileReader={importFile} />
        <ButtonExport
          berData={changeDefaultData}
          fileNameValue={changeNameFile}
        />
        <FileNameInput
          fileName={changeNameFile}
          changeFileName={(e) => {
            setChangeFileName(e.target.value);
          }}
        />
      </div>

      <div className="translation-form">
        <h1>TRANSLATION</h1>

        <div className="language-block">
          <AppBar position="relative">
            <Toolbar>
              <div className="language-bar">
                <p key="en">English</p>
                <p>
                  <i className="fas fa-arrow-right"></i>
                </p>
                <div>
                  <FormControl variant="outlined">
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={openSelect}
                      onChange={(event) => setOpenSelect(event.target.value)}
                      label="Language"
                    >
                      <MenuItem></MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          {defaultData.map((item) => (
            <Inputs
              data={item}
              onChange={(data) => {
                const saveData = [...changeDefaultData];
                const foundIndex = saveData.findIndex(
                  (value) => value.key === data.key
                );
                saveData[foundIndex] = data;
                setChangeDefaultData(saveData);
              }}
            />
          ))}
        </div>
        <ButtonSave />
      </div>
    </div>
  );
}
export default Mains;
